<section class="server-error-container">
  <img
    [src]="'/pia/assets/internal_server_error.png'"
    [alt]="'pia.shared.notFoundImageAltDescription' | translate"
    class="banner-image"
  />
  <div class="server-error-info">
    <h1 class="server-error-title font-3xl">
      {{ "shared.internalServerErrorTitle" | translate }}
    </h1>
    <p class="server-error-text font-m">
      {{ "shared.internalServerErrorDescription" | translate }}
    </p>
  </div>
  <a class="server-error-link font-m" routerLink="/pia">
    <claas-icon
      [id]="''"
      [iconId]="'648662'"
      [namespace]="'storybook'"
      [iconStyle]="'bold'"
      [size]="24"
      [alt]=""
      [removeDefaultColor]="true"
      [class]="'refresh-icon'"
    >
    </claas-icon>
    <span>{{ "shared.reloadButtonText" | translate }}</span>
  </a>
</section>
